<template>
  <section class="section__brilliant">
    
    <!-- All animating objects -->
    <div class="section__brilliant--bg">
      <div class="section__brilliant--scene">
        <!-- <transition :css="false" @leave="leaveMonsters" @enter="enterMonsters"> -->
          <img
            id="fox"
            class="lazyload"
            src="https://ik.imagekit.io/intervi/tr:bl-7/brilliantfox_r1x4IbRmw4.png"
            data-src="https://ik.imagekit.io/intervi/brilliantfox_r1x4IbRmw4.png"
            alt="fox"
          >
        <!-- </transition> -->
        <img id="fox-bg" class="lazyload" data-src="https://ik.imagekit.io/intervi/brilliantbg_ryx2YAQPV.jpg" alt="fox-bg">
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";

export default {
  name: "ComponentBrilliantMind",
  data() {
    return {
      // caseColor: "black",
      caseText: "Case study.",
      thisSection: 2
    };
  },
  props: ["showChild", "activeSection"],
  mounted: function() {
    this.mouseFox();
    this.mouseFoxBg();
  },
  methods: {
    mouseFox: function() {
      $(document).mousemove(function(event) {
        $("#fox").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -20,
            ease: Power1.easeOut
          });
        });
      });
    },

  mouseFoxBg: function() {
      $(document).mousemove(function(event) {
        $("#fox-bg").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 40,
            ease: Power1.easeOut
          });
        });
      });
    },

    // enter/leave animations
    // monsters
    // enterMonsters: function(el, done) {
    //   TweenMax.fromTo(
    //     el,
    //     1,
    //     { opacity: "0" },
    //     {
    //       opacity: "1",
    //       ease: Power1.easeInOut,
    //       delay: 0.5
    //     }
    //   );
    // },
    // leaveMonsters: function(el, done) {
    //   TweenMax.to(el, 1, { opacity: "0", ease: Power1.easeInOut });
    // }
  },
  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentBrilliantMind.vue